import { render, staticRenderFns } from "./PedidoAbaView.vue?vue&type=template&id=46d215bf"
import script from "./PedidoAbaView.vue?vue&type=script&lang=js"
export * from "./PedidoAbaView.vue?vue&type=script&lang=js"
import style0 from "./PedidoAbaView.vue?vue&type=style&index=0&id=46d215bf&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports